export class UserSettings {
  // @ts-expect-error: There is a null/undefined/typing issue; please fix me!
  public onboarding: boolean;
}
